import { v2Colors } from '@web-for-marketing/react-ui';

export const checkboxButtonStyles = {
    container: {
        position: 'relative',
    },
    contentContainer: {
        padding: '1.5rem 2rem',
        border: `1px solid ${v2Colors.core.smoke}`,
        borderRadius: '0.6rem',
        backgroundColor: v2Colors.core.snow,
        color: v2Colors.core.blackTarr,
        transition: 'color 200ms ease, background-color 200ms ease, border 200ms ease',
        '&:hover': {
            cursor: 'pointer',
            backgroundColor: '#E7F4FD',
            borderColor: v2Colors.core.blackTarr,
        },
    },
    hiddenCheckbox: {
        opacity: 0,
        height: 0,
        width: 0,
        position: 'absolute',
        top: 0,
        left: 0,
        '&:focus ~ div': {
            backgroundColor: '#E7F4FD',
            borderColor: v2Colors.core.blackTarr,
        },
        '&:focus ~ div > div': {
            borderColor: v2Colors.core.innovationDark,
        },
        '&:focus ~ div > p': {
            color: v2Colors.core.innovationDark,
        },
        '&:checked ~ div': {
            backgroundColor: '#E7F4FD',
            borderColor: v2Colors.core.blackTarr,
        },
        '&:checked ~ div > div': {
            backgroundColor: v2Colors.core.innovation,
            borderColor: v2Colors.core.innovation,
        },
        '&:checked ~ div:hover': {
            backgroundColor: '#BADDF7',
        },
        '&:checked:focus ~ div': {
            backgroundColor: '#BADDF7',
        },
        '&:checked:focus ~ div > p': {
            color: v2Colors.core.innovationDark,
        },
        '&:checked:focus ~ div > div': {
            backgroundColor: v2Colors.core.innovationDark,
            borderColor: v2Colors.core.innovationDark,
        },
    },
    checkbox: {
        width: '1.4rem',
        height: '1.4rem',
        borderRadius: '0.2rem',
        border: `1px solid ${v2Colors.core.blackTarr}`,
        marginRight: '1rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& > svg': {
            width: '80%',
        },
    },
    label: {
        color: 'inherit',
        fontSize: '1.4rem',
        flexShrink: 1000,
    },
} as const;
